import { ReactElement, useRef } from 'react';
import { Tooltip } from 'react-tooltip';

import { useContentOverflow } from '../../../hooks';

import styles from './styles.module.scss';

export const FileName = ({ name }: { name: string }): ReactElement => {
  const textRef = useRef<HTMLInputElement>(null);
  const isOverflowing = useContentOverflow(textRef);

  return (
    <div className={styles.tooltipContainer}>
      <div className={styles.fileName} id="fileNameHint" ref={textRef}>
        {name}
      </div>
      <Tooltip
        anchorSelect="#fileNameHint"
        place="top"
        noArrow
        opacity={1}
        className={styles.tooltip}
        hidden={!isOverflowing}
      >
        {name}
      </Tooltip>
    </div>
  );
};
